<template>
    <div id="app">
        <Header
            v-if="this.$store.getters['auth/user']"
            :left-menu-opened="leftMenuOpened"
            :consultantData="consultantData"
            :paidCompanies="paidCompanies"
            :availableLicenses="availableLicenses"
            :selectedPaid="getPaidLoaded()"
            @topMenuOpened="headerValues()"
        >
        </Header>
        <div class="content">
            <LeftNavigation
                v-if="this.$store.getters['auth/user']"
                :key="this.$store.getters['auth/user'] ? this.$store.getters['auth/user'].fundingsWishlistNumber : 0"
                :favNumberBadge="this.$store.getters['auth/user'] ? this.$store.getters['auth/user'].fundingsWishlistNumber : 0"
                :top-menu-is-opened="topMenuIsOpened"
                @leftMenuOpened="leftNavigationValues()"
            >
            </LeftNavigation>
            <b-overlay :show="appLoading" blur="20px" class="contentPage" :class="getCurrentPageSlug()">
                <template #overlay>
                    <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
                        <img src="@/assets/images/preloader.gif" style="max-width: 100px; height: auto; align-self: flex-start;">
                        <p style="font-size: 16px; font-weight: 600; text-align: center;">Smis se încarcă...</p>
                    </div>
                </template>
                <!--      @changedCId="getConsultantData($event)"          -->
                <router-view @sketchEntered="checkStateAids()" @changeCompany="getPaidInfo(); companyChanged($event)" @appLoading="appLoading = $event" @newCompanyAdded="newCompanyAdded($event)"></router-view>
            </b-overlay>
            <updateAnnouncement :showModal="showUpdateModal" @hideTempModal="showUpdateModal = false"></updateAnnouncement>
            <!--            <AppLoadingOverlay v-show="appLoading"></AppLoadingOverlay>-->

        </div>
    </div>
</template>

<script>
    import { BOverlay } from "bootstrap-vue";
    import Header from "./common/header/Header";
    import updateAnnouncement from "./common/updateAnnouncement";
    import AppLoadingOverlay from "./common/AppLoadingOverlay";
    import LeftNavigation from "./common/MenuLeftSide/LeftNavigation";
    import axios from '@/helpers/axios'
    import Cookies from 'js-cookie'
    import api from '@/helpers/api'
    import _ from "lodash";
    /*import Vue from "vue";*/
    export default {
        name: "App",
        components: {
            Header,
            updateAnnouncement,
            LeftNavigation,
            BOverlay,
            AppLoadingOverlay
        },
        data() {
            return {
                isLoginRegister: false,
                showUpdateModal: false,
                topMenuIsOpened: false,
                leftMenuOpened: false,
                consultantData: null,
                paidCompanies: null,
                allCompanies: [],
                selectedPaid: false,
                paidLoaded: false,
                availableLicenses: null,
                appLoading: false,
            }
        },
        computed: {
            pageLoading() {
                return this.$store.getters['pageLoading/pageLoading']
            },
            stateAids() {
                return this.$store.getters['stateAids/getStateAids']
            },
            fullPath() {
                return this.$route.fullPath
            },
        },
        watch: {
            pageLoading: {
                handler() {
                    this.appLoading = this.pageLoading
                },
                immediate: true
            },
            fullPath: {
                handler() {
                    this.showUpdateModal = true;
                },
                deep: true
            }
        },
        created() {
            this.paidLoaded = false
        },
        mounted(){
            if(this.$store.getters['auth/user'])
                this.getPaidInfo()
            this.track()
            if(!this.stateAids && JSON.parse(localStorage.getItem('currentM3Company')) && JSON.parse(localStorage.getItem('currentM3Company')).business_id && this.$store.getters['auth/user']) {
                this.getCompanyStateAids(JSON.parse(localStorage.getItem('currentM3Company')).business_id)
            }
            this.showUpdateModal = true
        },
        updated() {
        },
        methods: {
            companyChanged(companyID) {
                this.$store.dispatch('companyChanged/setChanged', false);
                this.getCompanyStateAids(companyID)
            },
            newCompanyAdded(companyID) {
                this.getCompanyStateAids(companyID)
            },
            checkStateAids() {
                if(!this.stateAids && JSON.parse(localStorage.getItem('currentM3Company')) && JSON.parse(localStorage.getItem('currentM3Company')).business_id) {
                    this.getCompanyStateAids(JSON.parse(localStorage.getItem('currentM3Company')).business_id)
                }
            },
            getCompanyStateAids(companyID) {
                axios.get(api.API_ENDPOINTS.getStateAids + companyID)
                    .then( response => {
                        this.$store.dispatch('stateAids/setAids', response.data)
                    })
                    .catch( xhr => {
                        console.log(xhr);
                    })
            },
            async getPaidLoaded() {
                if(!this.paidLoaded && this.$store.getters['auth/user'])
                    await this.getPaidInfo()

                if(!localStorage.getItem('currentM3Company') || this.allCompanies.length === 0)
                    return false

                return this.selectedPaid
            },
            track() {
                if(
                    this.$route.query.utm_campaign && this.$route.query.utm_medium && this.$route.query.utm_source &&
                    ! Cookies.get('utm_campaign') && ! Cookies.get('utm_medium') && ! Cookies.get('utm_source')
                ) {
                    Cookies.set('utm_campaign', this.$route.query.utm_campaign, { domain: '.smis.ro' })
                    Cookies.set('utm_medium', this.$route.query.utm_medium, { domain: '.smis.ro' })
                    Cookies.set('utm_source', this.$route.query.utm_source, { domain: '.smis.ro' })

                    if(this.$route.query.utm_ref) {
                        Cookies.set('utm_ref', this.$route.query.utm_ref, { domain: '.smis.ro' })
                    }
                }
            },
            headerValues(){
                this.topMenuIsOpened = true;
                this.leftMenuOpened = false
            },
            leftNavigationValues(){
                this.leftMenuOpened = true;
                this.topMenuIsOpened = false
            },
            getPaidInfo() {
                axios.get(api.API_ENDPOINTS.m3company)
                    .then(response => {
                        this.allCompanies = response.data
                        this.paidCompanies = response.data ? _.filter(response.data, v => v.paid).length : 0;
                        if(JSON.parse(localStorage.getItem('currentM3Company'))) {
                            this.selectedPaid = _.filter(this.allCompanies, v => v.id === JSON.parse(localStorage.getItem('currentM3Company')).id)[0] ?_.filter(this.allCompanies, v => v.id === JSON.parse(localStorage.getItem('currentM3Company')).id)[0].paid : false
                            this.availableLicenses = _.filter(this.allCompanies, v => v.id === JSON.parse(localStorage.getItem('currentM3Company')).id)[0] ?_.filter(this.allCompanies, v => v.id === JSON.parse(localStorage.getItem('currentM3Company')).id)[0].available_licenses : null
                            this.paidLoaded = true
                        }
                        /*this.$store.dispatch('pageLoading/setLoading', false)*/
                    })
            },
            getCurrentPageSlug() {
                let fullPathArr = this.$route.fullPath.split('/').slice(-2).join('-')
                return fullPathArr
            }
            /*getConsultantData(event) {
                if(event){
                    axios.get(api.API_ENDPOINTS.m3company + event + '/consultant')
                        .then( response => {
                            if(response.data){
                                this.consultantData = {
                                    name: response.data.name ? response.data.name : '',
                                    user_logo: response.data.user_logo ? response.data.user_logo : '',
                                    email: response.data.email ? response.data.email : '',
                                    phone: response.data.phone ? response.data.phone : '',
                                    whatsapp_phone: response.data.whatsapp_phone ? response.data.whatsapp_phone : ''
                                }
                            } else{
                                this.consultantData = {}
                            }
                        })
                        .finally(() => this.loading = false)
                        .catch( xhr => {
                            console.log(xhr);
                        })
                }
            }*/
        },
    };
</script>
<style>
.content{
    min-height: 100%;
    display: flex;
    height: 100%;
}
#nav a {
    color: #212121;
}

.current-tab {
    border-radius: 3px;
    border-right: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    width: 100%;
    box-sizing: border-box;
    background-color: #f0f0f0;
    display: flex;
}
@media (max-width:540px) {
    .content{
        height: 100%;
    }
}
</style>
